import { useMemo } from 'react';
import { useQuery } from 'convex/react';
import { api } from '../../convex/_generated/api'; // DEEP_IMPORT_JUSTIFIED: Convex generated API lives outside src/
import { useSuperadminContext } from './useSuperadminContext';
import { useOrgContext } from './useOrgContext';

export function useControlDashboardStats() {
  const { isSuperadmin } = useSuperadminContext();
  const { currentOrg } = useOrgContext();
  const analyticsSummary = useQuery(
    api.superadmin.queries.getPolicyAnalyticsSummary,
    isSuperadmin ? {} : 'skip'
  );
  const allOrgs = useQuery(api.superadmin.queries.listAllOrganisations, isSuperadmin ? {} : 'skip');
  const allUsers = useQuery(api.superadmin.queries.listAllUsers, isSuperadmin ? {} : 'skip');
  const orgAnalytics = useQuery(api.superadmin.queries.getPolicyAnalyticsByOrg, 'skip');

  return useMemo(
    () => ({
      isSuperadmin,
      totalUsers: allUsers?.length,
      totalOrgs: allOrgs?.length,
      totalCompanies: allOrgs?.reduce((sum, o) => sum + o.companyCount, 0),
      totalPolicies: analyticsSummary?.totalPolicies,
      activePolicies: analyticsSummary?.activePolicies,
      orgPolicies: orgAnalytics?.[0]?.totalPolicies,
      orgName: currentOrg?.name,
      isLoading: isSuperadmin
        ? allUsers === undefined || allOrgs === undefined || analyticsSummary === undefined
        : orgAnalytics === undefined,
    }),
    [isSuperadmin, allUsers, allOrgs, analyticsSummary, orgAnalytics, currentOrg]
  );
}
